export default __webpack_public_path__ + "static/media/Mercenary's Belt of the Elder Bond.24cce5fc.jpg";